/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FacebookOutlined } from '@ant-design/icons';
import { Avatar, Button, Popover } from 'antd';
import { useAppDispatch, useAuthState } from '@core/configureStore';
import { heroApiService } from '@services/service-register';
import { OAUTH_ROUTE } from '@constants/social';
import { connectToThirdParty } from '@core/features';

type Props = {};

const ConnectFacebookButton = (props: Props) => {
  const { user, integration: social } = useAuthState();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const handleRefresh = async () => {
    setLoading(true);
    try {
      const socialAccount = await heroApiService.getFacebookProfile();
      await dispatch(
        connectToThirdParty({
          platform: 'facebook',
          profile: socialAccount,
        })
      );
    } catch (error: any) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleLogOutFacebook = async () => {
    setLoading(true);
    try {
      await heroApiService.logoutFacebook();
      await handleRefresh();
      location.reload();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      await handleRefresh();
    };
    init();
  }, [user]);

  return social.facebook ? (
    <Popover trigger={'click'} content={<Button onClick={handleLogOutFacebook}>Log out</Button>}>
      <Button
        loading={loading}
        type="primary"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <Avatar size={20} style={{ marginRight: 10 }}>
          {social.facebook.name.slice(0, 1)}
        </Avatar>
        {social.facebook.name}
      </Button>
    </Popover>
  ) : (
    <a href={OAUTH_ROUTE}>
      <Button loading={loading}>
        <FacebookOutlined /> Connect to Facebook
      </Button>
    </a>
  );
};

export default ConnectFacebookButton;
